import React from "react";
import PropTypes from "prop-types";
import { TextButton } from "@qgiv/core-donor";
import "./WantToLogInButton.scss";

const WantToLogInButton = ({ displayWantToLogInButton, donorActionUrl }) => {
    // Redirect the user to their login page
    const handleWantToLogInClick = () => {
        window.location.href = donorActionUrl;
    };

    return displayWantToLogInButton ? (
        <div className="want-to-login-button col col--12">
            <TextButton handleClick={handleWantToLogInClick}>
                <strong>I want to log in.</strong>
            </TextButton>
        </div>
    ) : null;
};

WantToLogInButton.propTypes = {
    displayWantToLogInButton: PropTypes.bool.isRequired,
    donorActionUrl: PropTypes.string.isRequired,
};

export default WantToLogInButton;
